import * as React from 'react';

// tslint:disable-next-line: no-any
export function getDisplayName(Component: React.ComponentType<unknown>): string {
  return Component.displayName || Component.name || 'Component';
}
